import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const FilterControls = ({ onFiltersChange, activeFilters }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const serviceCategories = [
    { value: 'all', label: 'All Services' },
    { value: 'internet', label: 'Internet Providers' },
    { value: 'mobile', label: 'Mobile Carriers' },
    { value: 'streaming', label: 'Streaming Services' },
    { value: 'cloud', label: 'Cloud Services' },
    { value: 'financial', label: 'Financial Services' },
    { value: 'gaming', label: 'Gaming Platforms' }
  ];

  const severityLevels = [
    { value: 'all', label: 'All Severities' },
    { value: 'critical', label: 'Critical' },
    { value: 'major', label: 'Major' },
    { value: 'minor', label: 'Minor' }
  ];

  const regions = [
    { value: 'all', label: 'All Regions' },
    { value: 'north-america', label: 'North America' },
    { value: 'europe', label: 'Europe' },
    { value: 'asia-pacific', label: 'Asia Pacific' },
    { value: 'south-america', label: 'South America' },
    { value: 'africa', label: 'Africa' }
  ];

  const timeRanges = [
    { value: 'live', label: 'Live (Last 1h)' },
    { value: '6h', label: 'Last 6 hours' },
    { value: '24h', label: 'Last 24 hours' },
    { value: '7d', label: 'Last 7 days' },
    { value: '30d', label: 'Last 30 days' }
  ];

  const handleFilterChange = (filterType, value) => {
    onFiltersChange({
      ...activeFilters,
      [filterType]: value
    });
  };

  const clearAllFilters = () => {
    onFiltersChange({
      category: 'all',
      severity: 'all',
      region: 'all',
      timeRange: 'live'
    });
  };

  const hasActiveFilters = Object.values(activeFilters)?.some(value => value !== 'all' && value !== 'live');

  return (
    <div className="bg-card border border-border rounded-lg p-4">
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-2">
          <Icon name="Filter" size={20} className="text-foreground" />
          <h3 className="font-semibold text-foreground">Filters</h3>
          {hasActiveFilters && (
            <div className="flex items-center justify-center w-5 h-5 bg-primary text-primary-foreground rounded-full text-xs font-medium">
              {Object.values(activeFilters)?.filter(value => value !== 'all' && value !== 'live')?.length}
            </div>
          )}
        </div>
        <div className="flex items-center space-x-2">
          {hasActiveFilters && (
            <Button
              variant="ghost"
              size="sm"
              onClick={clearAllFilters}
              className="text-xs"
            >
              Clear All
            </Button>
          )}
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setIsExpanded(!isExpanded)}
            className="md:hidden"
          >
            <Icon name={isExpanded ? "ChevronUp" : "ChevronDown"} size={16} />
          </Button>
        </div>
      </div>
      {/* Filter Controls */}
      <div className={`space-y-4 ${isExpanded ? 'block' : 'hidden md:block'}`}>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {/* Service Category */}
          <Select
            label="Service Category"
            options={serviceCategories}
            value={activeFilters?.category}
            onChange={(value) => handleFilterChange('category', value)}
            className="w-full"
          />

          {/* Severity */}
          <Select
            label="Severity Level"
            options={severityLevels}
            value={activeFilters?.severity}
            onChange={(value) => handleFilterChange('severity', value)}
            className="w-full"
          />

          {/* Region */}
          <Select
            label="Geographic Region"
            options={regions}
            value={activeFilters?.region}
            onChange={(value) => handleFilterChange('region', value)}
            className="w-full"
          />

          {/* Time Range */}
          <Select
            label="Time Range"
            options={timeRanges}
            value={activeFilters?.timeRange}
            onChange={(value) => handleFilterChange('timeRange', value)}
            className="w-full"
          />
        </div>

        {/* Quick Filter Chips */}
        <div className="flex flex-wrap gap-2 pt-2 border-t border-border">
          <span className="text-sm text-muted-foreground">Quick filters:</span>
          {['Critical Only', 'Last Hour', 'Major Providers', 'My Region']?.map((chip) => (
            <button
              key={chip}
              className="px-3 py-1 text-xs bg-muted hover:bg-muted/80 text-muted-foreground rounded-full transition-colors duration-200"
            >
              {chip}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FilterControls;